import React from 'react'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap'
import UsersForm from '../Forms/Users.Form'

export default class UsersModal extends React.Component {
    constructor(props) {
		super(props)
		this.state = { modal: false }
    }

    toggle = () => {
		this.setState(prevState => ({
			modal: !prevState.modal
		}))
    }

    render() {
        const closeBtn = <button className="close" onClick={this.toggle}> &times; </button>
		const label = this.props.buttonLabel
		let button = ''
        let title = ''
        
        if (label === "Edit") {
			button = 
				<Button color="warning"
					onClick={this.toggle}
					style={{ float: "left", marginRight: "10px"}} >
					{label}
				</Button>
				title = "Edit User"
		} else {
			button = 
				<Button color="success"
					onClick={this.toggle}
					style={{ float: "left", marginRight: "10px" }}>
						{label}
				</Button>
				title = "Add New User"
        }

        return (
            <>
                {button}
                <Modal isOpen={this.state.modal} toggle={this.toggle} className={this.props.className}>
                    <ModalHeader toggle={this.toggle} close={closeBtn}> {title}	</ModalHeader>
                    <ModalBody>
                        <UsersForm
                            addUserToState={this.props.addUserToState}
                            updateUsersState={this.props.updateUsersState}
                            getUsers={this.props.getUsers}
                            toggle={this.toggle}
                            user={this.props.user} />
                    </ModalBody>
                    <ModalFooter>
                        <Button color="primary" onClick={this.toggle}>Submit</Button>
                        <Button color="secondary" onClick={this.toggle}>Batal</Button>
                    </ModalFooter>
                </Modal>
            </>
        )
    }
}